
const KPIStatDataAPI = (response) => {

    const datosKPIStat = []


    //Obtendo los array con las series y los colores. Solo 1 registro por serie y por color (uniqueSeries y uniqueColors)
    response.data.map(item => {

        datosKPIStat.push(
            {
                Title: item.Title,
                Value: item.Value,
                TargetValue: item.TargetValue,
                IconName: item.IconName,
                IconRoot: item.IconRoot,
                IconColor: item.IconColor,
                imageUrl: item.imageUrl
            }
        )

    });


    return datosKPIStat
}

export default KPIStatDataAPI




